/*#####################
### Cookie popup ###
#####################*/

const $cookiePopup = $('.js-cookie');
const $closeCookiePopup = $('.js-close-popup');
const $openCookieModal = $('.js-open-modal');
const $modal = $('.cookie__modal');
const $toggleStatistic = $('#statistics');
const $saveBtn = $('.cookie__modal-save-btn');

function setCookieToTrue() {
    localStorage.setItem('nordural_cookie', 'true');
}
function showCookiePopup() {
    $cookiePopup.css('bottom', '15px');
}
function hideCookiePopup() {
    $cookiePopup.css('bottom', '-500px');
    setCookieToTrue();
}
function createCoockieAndEnableGA() {
    document.cookie = 'nordural_cookie_consent=yes;expires=Thu, 7 Feb 2023 12:00:00 UTC;';
    window['ga-disable-UA-98410769-1'] = false
}
function createCoockieAndDisableGA() {
    document.cookie = 'nordural_cookie_consent=no;expires=Thu, 7 Feb 2023 12:00:00 UTC;';
    window['ga-disable-UA-98410769-1'] = true
}
/*#####################
### DOM ready calls ###
#####################*/
jQuery( function( $ ) {

    //Show popup after 2 seconds
    let cookieStore = localStorage.getItem('nordural_cookie');
    if (cookieStore !== 'true') {
        setTimeout(showCookiePopup, 2000);
    }

    // Close cookie popup
    $closeCookiePopup.on('click', hideCookiePopup);
    //Open cookie modal
    $openCookieModal.click(function() {
        // Close cookie popup
        $cookiePopup.css('bottom', '-500px');
        $modal.css('display', 'flex');
        $('body').css('overflow', 'hidden');
    });

    // Save and close modal
    $saveBtn.click(function() {
        $modal.css('display', 'none');
        $('body').css('overflow', 'auto');

        const $isCheck = $toggleStatistic.prop("checked");

        if($isCheck === true) {
            createCoockieAndEnableGA();
        } else {
            createCoockieAndDisableGA();
        }

        setCookieToTrue();
    });    
});
